<template>
    <button v-loading="loading" @mousedown="downloadFile" ><i class="fa fa-file-export"></i>Export</button>
</template>

<script>
    import html2pdf from "html2pdf.js";
    export default {
        computed: {
        },
         data() {
            return {
                loading:false
            }
        },
        props: ["dom", "name"],
        methods: {
            downloadFile() {
                this.loading = true;
                const me = this;
                const Data = document.querySelector(me.dom);
                var opt = {
                    margin: [5, 5],
                    top: 0,
                    filename: me.name,
                    image: {type: 'png'},
//                    html2canvas: {scale: 2, scrollY: 3},
                    html2canvas: {scale: 2, scrollY: 3,dpi: 192, letterRendering: true, useCORS: true},
                    jsPDF: {unit: 'mm', format: 'A4', orientation: 'landscape'},
                    pagebreak: {avoid: 'tr,table,h6',after:'.html2pdf__page-break'}

                };
                html2pdf().from(Data).set(opt).save();
                this.loading = false;
            },
        },
    };
</script>